export function isMember(patient) {
  return patient.type === 'You';
}
